import { render, staticRenderFns } from "./addDoc.vue?vue&type=template&id=0b03ebd4"
import script from "./addDoc.vue?vue&type=script&lang=js"
export * from "./addDoc.vue?vue&type=script&lang=js"
import style0 from "./addDoc.vue?vue&type=style&index=0&id=0b03ebd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports